<template>
  <div class="p-2 rounded-xl min-h-screen">
    <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-3 mb-4 shadow-sm border border-gray-100">
      <h2 class="text-sm font-bold text-gray-700 mb-2">محصولات ویژه</h2>
      <p class="text-xs text-gray-500">
        محصولاتی که اینجا اضافه می‌کنید، در صفحه اصلی سایت و در سبد خرید با اولویت بیشتری نمایش داده می‌شوند.
      </p>
    </div>

    <!-- افزودن محصول جدید -->
    <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-3 mb-4 shadow-sm border border-gray-100">
      <h3 class="text-xs font-bold text-gray-700 mb-2">افزودن محصول به لیست ویژه</h3>
      <div class="flex items-center gap-2 mb-2">
        <input
            v-model="searchQuery"
            placeholder="نام محصول را جستجو کنید"
            class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-64 text-right"
            @keyup.enter="searchProducts"
        >
        <button
            @click="searchProducts"
            class="px-3 py-1.5 bg-gray-800 text-white text-xs rounded-lg"
        >جستجو</button>
      </div>

      <table class="w-full text-right" v-if="searchResults.length">
        <tbody>
        <tr v-for="product in searchResults" :key="product.id" class="border-t hover:bg-gray-50">
          <td class="p-2 w-12">
            <img :src="img_source(product.image)" class="w-10 h-10 object-cover rounded-lg" v-if="product.image">
          </td>
          <td class="p-2 text-xs text-gray-700">{{ product.name }}</td>
          <td class="p-2 text-xs text-gray-500">{{ product.brand && product.brand.name }}</td>
          <td class="p-2 w-28">
            <button
                v-if="!product.boost_at"
                @click="addToFeatured(product)"
                :disabled="boostingId === product.id"
                class="px-3 py-1 bg-emerald-600 text-white text-[11px] rounded-lg"
            >افزودن</button>
            <button
                v-else
                @click="removeFromFeatured(product)"
                :disabled="boostingId === product.id"
                class="px-3 py-1 bg-red-500 text-white text-[11px] rounded-lg"
            >حذف از ویژه</button>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-else-if="searched && !searching" class="text-xs text-gray-400 p-2">محصولی پیدا نشد</div>
    </div>

    <!-- لیست محصولات ویژه فعلی -->
    <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <div class="flex items-center justify-between p-3 border-b">
        <h3 class="text-xs font-bold text-gray-700">محصولات ویژه فعلی ({{ totalProducts }})</h3>
        <button
            v-if="totalProducts"
            @click="clearAllFeatured"
            :disabled="clearingAll"
            class="px-3 py-1.5 bg-red-600 text-white text-xs rounded-lg"
        >پاک کردن همه محصولات ویژه</button>
      </div>
      <table class="w-full text-right">
        <thead class="bg-gray-50">
        <tr>
          <th class="p-3 text-xs font-medium text-gray-500 uppercase">تصویر</th>
          <th class="p-3 text-xs font-medium text-gray-500 uppercase">نام محصول</th>
          <th class="p-3 text-xs font-medium text-gray-500 uppercase">برند</th>
          <th class="p-3 text-xs font-medium text-gray-500 uppercase">موجودی</th>
          <th class="p-3 text-xs font-medium text-gray-500 uppercase"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="loading">
          <td colspan="5" class="p-6 text-center text-xs text-gray-400">در حال بارگذاری...</td>
        </tr>
        <tr v-else-if="!products.length">
          <td colspan="5" class="p-6 text-center text-xs text-gray-400">هنوز محصولی به لیست ویژه اضافه نشده</td>
        </tr>
        <tr v-for="product in products" :key="product.id" class="border-t hover:bg-gray-50">
          <td class="p-2">
            <img :src="img_source(product.image)" class="w-10 h-10 object-cover rounded-lg" v-if="product.image">
          </td>
          <td class="p-2 text-xs text-gray-700">{{ product.name }}</td>
          <td class="p-2 text-xs text-gray-500">{{ product.brand && product.brand.name }}</td>
          <td class="p-2 text-xs text-gray-500">{{ product.calculate_current_inventory }}</td>
          <td class="p-2">
            <button
                @click="removeFromFeatured(product)"
                :disabled="boostingId === product.id"
                class="px-3 py-1 bg-red-500 text-white text-[11px] rounded-lg"
            >حذف از ویژه</button>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="flex items-center justify-between p-3 border-t text-xs text-gray-500" v-if="totalProducts">
        <span>مجموع: {{ totalProducts }}</span>
        <div class="flex items-center gap-2">
          <button
              class="px-2 py-1 rounded-lg border disabled:opacity-40"
              :disabled="currentPage <= 1"
              @click="currentPage--; fetchProducts()"
          >قبلی</button>
          <span>صفحه {{ currentPage }} از {{ totalPages }}</span>
          <button
              class="px-2 py-1 rounded-lg border disabled:opacity-40"
              :disabled="currentPage >= totalPages"
              @click="currentPage++; fetchProducts()"
          >بعدی</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MarketingProductList",
  data() {
    return {
      products: [],
      loading: false,
      boostingId: null,
      totalProducts: 0,
      currentPage: 1,
      itemsPerPage: 24,
      searchQuery: "",
      searchResults: [],
      searching: false,
      searched: false,
      clearingAll: false,
    };
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.totalProducts / this.itemsPerPage));
    },
  },
  created() {
    this.setDocumentTitle && this.setDocumentTitle("محصولات ویژه");
    this.fetchProducts();
  },
  methods: {
    clearAllFeatured() {
      if (!window.confirm(`همه‌ی ${this.totalProducts} محصول از لیست ویژه حذف بشن؟ این کار قابل بازگشت خودکار نیست.`)) {
        return;
      }
      this.clearingAll = true;
      this.request({
        url: this.endpoint("product/adminProductBoost/clearAll"),
        method: "post",
        success: (data) => {
          this.clearingAll = false;
          this.notify && this.notify(`${data.cleared} محصول از لیست ویژه حذف شد`, "success");
          this.currentPage = 1;
          this.fetchProducts();
          this.searchResults.forEach((p) => { p.boost_at = null; });
        },
        error: () => {
          this.clearingAll = false;
          this.notify && this.notify("خطا در پاک کردن لیست ویژه", "danger");
        },
      });
    },
    fetchProducts() {
      this.loading = true;
      this.request({
        url: this.endpoint("shop/adminProducts"),
        method: "get",
        params: {
          limit: this.itemsPerPage,
          offset: (this.currentPage - 1) * this.itemsPerPage,
          boosted: true,
        },
        success: (data) => {
          this.products = data.results || [];
          this.totalProducts = data.count || 0;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
    },
    searchProducts() {
      if (!this.searchQuery.trim()) {
        this.searchResults = [];
        this.searched = false;
        return;
      }
      this.searching = true;
      this.searched = true;
      this.request({
        url: this.endpoint("shop/adminProducts"),
        method: "get",
        params: {
          limit: 20,
          offset: 0,
          search_value: this.searchQuery,
        },
        success: (data) => {
          this.searchResults = data.results || [];
          this.searching = false;
        },
        error: () => {
          this.searching = false;
        },
      });
    },
    addToFeatured(product) {
      this.setBoost(product, true, () => {
        this.currentPage = 1;
        this.fetchProducts();
      });
    },
    removeFromFeatured(product) {
      this.setBoost(product, false, () => {
        this.fetchProducts();
        const inSearch = this.searchResults.find((p) => p.id === product.id);
        if (inSearch) inSearch.boost_at = null;
      });
    },
    setBoost(product, boosted, onDone) {
      this.boostingId = product.id;
      this.request({
        url: this.endpoint(`product/adminProductBoost/${product.id}`),
        method: "put",
        data: { boosted },
        success: (data) => {
          product.boost_at = data.boost_at;
          this.boostingId = null;
          this.notify && this.notify(boosted ? "محصول به لیست ویژه اضافه شد" : "محصول از لیست ویژه حذف شد", "success");
          onDone && onDone();
        },
        error: () => {
          this.boostingId = null;
          this.notify && this.notify("خطا در تغییر وضعیت ویژه", "danger");
        },
      });
    },
  },
};
</script>
